import { type FieldProps } from 'react-final-form';

export enum FilterItemType {
  checkbox = 'checkbox',
  radio = 'radio'
}

export type SelectOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

export type FilterItemCheckbox = {
  type: FilterItemType.checkbox;
  options: SelectOption[];
  label: string;
  name: string;
  disabled?: boolean;
  fieldProps?: Partial<FieldProps<any, any>>;
};

export type FilterItemRadio = {
  type: FilterItemType.radio;
  options: SelectOption[];
  label: string;
  name: string;
  disabled?: boolean;
  fieldProps?: Partial<FieldProps<any, any>>;
};

export type FilterItem = FilterItemCheckbox | FilterItemRadio;
